(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/info-overlay.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/info-overlay.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useContext,
  useEffect,
  useRef,
  useCallback
} = React;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  ReactIcon: Icon,
  ReactButton: Button,
  ReactCard: {
    Card
  },
  ReactRibbon: {
    RibbonCorner
  }
} = svs.ui;
const {
  Image
} = svs.content.image_v2;
const {
  useHistory
} = ReactRouterDOM;
const SimilarGames = _ref => {
  let {
    ticketInfo
  } = _ref;
  const {
    useGamesByTags
  } = svs.eInstant.shared.hooks;
  const {
    Background,
    TicketsRowWrapper
  } = svs.eInstant.shared.components;
  const {
    games,
    loading
  } = useGamesByTags({
    game: ticketInfo
  });
  if (loading || !games || !games.length) {
    return null;
  }
  const category = {
    games,
    title: 'Liknande spel',
    icon: 'tips',
    columns: {
      am: 4,
      md: 4
    }
  };
  return React.createElement(Background, {
    classNames: "padding-top-3 padding-bottom-2 padding-h-1"
  }, React.createElement(TicketsRowWrapper, {
    category: category
  }));
};
const InfoOverlay = _ref2 => {
  let {
    ticketInfo,
    onCloseUrl
  } = _ref2;
  const {
    ButtonsBlock
  } = svs.eInstant.shared.components;
  const infoRef = useRef(null);
  const history = useHistory();
  const {
    GAME_URL
  } = svs.eInstant.store.actions;
  const {
    dispatch,
    state
  } = useContext(svs.eInstant.store.RouterContext);
  const wrapperRef = useRef(null);
  const {
    saveScroll
  } = svs.eInstant.shared.hooks.useScrollPosition({
    element: wrapperRef
  });
  const {
    name,
    tags,
    description,
    maxPrice,
    minPrice,
    maxWin,
    imageBackground,
    gamePreview,
    logotype,
    badge,
    playUrl,
    demoUrl
  } = ticketInfo || {};
  const background = gamePreview || imageBackground;
  const onClose = useCallback(() => {
    var _document$querySelect;
    (_document$querySelect = document.querySelector('html')) === null || _document$querySelect === void 0 || _document$querySelect.classList.remove('einstant-info-disable-scroll');
    window.history.pushState(null, '', onCloseUrl);
    dispatch({
      type: GAME_URL,
      payload: {
        gameUrl: null
      }
    });
  }, [onCloseUrl, dispatch, GAME_URL]);
  const onOverlayClick = _ref3 => {
    let {
      target
    } = _ref3;
    if (!infoRef.current.contains(target)) {
      onClose();
    }
  };

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') return onClose();
      if (event.key === 'Tab' && infoRef.current) {
        const focusable = infoRef.current.querySelectorAll('button:not([disabled]), [href]:not([disabled])');
        const [first, last] = [focusable[0], focusable[focusable.length - 1]];
        if (event.shiftKey && document.activeElement === first || !event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);
  const handleClickPlay = () => {
    if (svs.tur.PauseCheck.isBlocked()) {
      svs.tur.apierrors.showErrorMessage({
        response: {
          error: {
            code: 1019
          }
        }
      });
      return;
    }
    saveScroll();
    dispatch({
      type: GAME_URL,
      payload: {
        gameUrl: null
      }
    });
    svs.eInstant.tracking.trackPlay(name, false);
    const returnUrl = location.pathname;
    history.push("".concat(playUrl, "?returnUrl=").concat(encodeURIComponent(returnUrl)));
  };
  const handleClickDemoPlay = () => {
    saveScroll();
    dispatch({
      type: GAME_URL,
      payload: {
        gameUrl: null
      }
    });
    svs.eInstant.tracking.trackPlay(name, true);
    const returnUrl = location.pathname;
    history.push("".concat(demoUrl, "?returnUrl=").concat(encodeURIComponent(returnUrl)));
  };
  useEffect(() => {
    var _document$querySelect2, _infoRef$current;
    (_document$querySelect2 = document.querySelector('html')) === null || _document$querySelect2 === void 0 || _document$querySelect2.classList.add('einstant-info-disable-scroll');

    const firstFocusable = (_infoRef$current = infoRef.current) === null || _infoRef$current === void 0 ? void 0 : _infoRef$current.querySelector('[aria-label="Stäng spelinformation"]');
    firstFocusable === null || firstFocusable === void 0 || firstFocusable.focus();
    return () => {
      var _document$querySelect3;
      return (_document$querySelect3 = document.querySelector('html')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.classList.remove('einstant-info-disable-scroll');
    };
  }, [ticketInfo]);
  useEffect(() => {
    const match = svs.eInstant.util.infoPageMatch();
    if (!match) {
      dispatch({
        type: GAME_URL,
        payload: {
          gameUrl: null
        }
      });
    }
  }, [location.pathname]);
  if (!state.gameUrl) {
    return null;
  }
  return React.createElement("div", {
    "aria-describedby": "info-overlay-description",
    "aria-labelledby": "info-overlay-title",
    "aria-modal": "true",
    className: "fixed w100 tickets-einstant-info-overlay u-flex u-flex-justify-content-center u-top-0 h100",
    onClick: onOverlayClick,
    role: "dialog"
  }, React.createElement("div", {
    className: "absolute tickets-einstant-info-container w100",
    ref: infoRef
  }, React.createElement(Grid, null, React.createElement(GridRow, {
    className: "u-flex u-flex-align-items-center u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    am: 12,
    xs: 12
  }, React.createElement(Card, {
    className: "f-body margin-h-1 margin-v-1 relative"
  }, React.createElement("div", {
    className: "u-flex u-flex-align-items-center u-flex-justify-content-center relative einstant-info-overlay-card-image-background"
  }, React.createElement(Image, {
    image: _objectSpread(_objectSpread({}, background), {}, {
      fitWrapper: true
    }),
    loadingLazy: true
  }), logotype && React.createElement(Image, {
    cssSelectors: "padding-half",
    image: logotype,
    loadingLazy: true
  }), badge && React.createElement("div", {
    "aria-hidden": "true"
  }, React.createElement(RibbonCorner, {
    className: "ribbon-corner-branding-fler-lotter",
    size: 700
  }, badge))), React.createElement(Button, {
    "aria-label": "St\xE4ng spelinformation",
    circle: true,
    className: "absolute margin-1 einstant-info-overlay-close-button tickets-einstant-button-theme",
    onClick: onClose
  }, React.createElement(Icon, {
    icon: "close",
    size: "300"
  })), React.createElement("div", {
    className: "einstant-info-overlay-card-body padding-h-1 bg-fler-lotter-new-500"
  }, React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center einstant-info-overlay-card-body-content h100"
  }, React.createElement("div", {
    className: "w100"
  }, React.createElement("h1", {
    className: "h1 align-center margin-v-1 fc-fler-lotter-new-300",
    id: "info-overlay-title"
  }, name), React.createElement("div", {
    className: "margin-v-1"
  }, (tags === null || tags === void 0 ? void 0 : tags.length) > 0 && React.createElement("div", {
    className: "align-center margin-0 fc-fler-lotter-new-400 relative"
  }, React.createElement("span", {
    className: "f-400 fc-fler-lotter-new-300 einstant-info-overlay-tags"
  }, tags.join(', ')))), React.createElement("p", {
    className: "p align-center margin-bottom-2 fc-fler-lotter-new-400 einstant-info-overlay-card-body-content-desc",
    id: "info-overlay-description"
  }, description)), React.createElement("div", {
    className: "w100"
  }, React.createElement(ButtonsBlock, {
    game: _objectSpread({}, ticketInfo),
    onDemoClick: handleClickDemoPlay,
    onPlayClick: handleClickPlay
  })), React.createElement("div", {
    className: "w100 margin-v-2"
  }, React.createElement("div", {
    className: "u-flex u-flex-row"
  }, React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center"
  }, React.createElement("span", {
    className: "fc-fler-lotter-new-300 margin-bottom-half"
  }, "Insats"), React.createElement("h4", {
    className: "h4 fc-fler-lotter-new-300 margin-bottom-0"
  }, maxPrice ? "".concat(minPrice, " - ").concat(maxPrice, " kr") : "".concat(minPrice, " kr"))), React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center einstant-info-overlay-margin-left-auto"
  }, React.createElement("span", {
    className: "fc-fler-lotter-new-300 margin-bottom-half"
  }, "Maxvinst"), React.createElement("h4", {
    className: "h4 fc-fler-lotter-new-300 margin-bottom-0"
  }, "".concat(svs.utils.format.Currency(maxWin), " kr"))))))), React.createElement(SimilarGames, {
    ticketInfo: ticketInfo
  })))))));
};
setGlobal('svs.eInstant.shared.components.InfoOverlay', _ref4 => {
  let {
    onCloseUrl = svs.core.data.baseUrl
  } = _ref4;
  const {
    INFO
  } = svs.eInstant.constants.ROUTES;
  const {
    state: {
      gameUrl
    }
  } = useContext(svs.eInstant.store.RouterContext);
  const {
    useTicketInfo
  } = svs.eInstant.shared.hooks;
  const {
    ticketInfo = null
  } = useTicketInfo({
    gameId: gameUrl
  });
  const {
    update
  } = svs.eInstant.shared.hooks.useMetaTags({
    ticketInfo
  });
  useEffect(() => {
    ticketInfo && update(INFO);
  }, [ticketInfo]);
  if (!ticketInfo) {
    return null;
  }
  return React.createElement(InfoOverlay, {
    onCloseUrl: onCloseUrl,
    ticketInfo: ticketInfo
  });
});

 })(window);